import { faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";
import {
  GSButton,
  GSFileSelect,
} from "golfstatus_react_components";
import { useImageSelector } from "../../hooks/formHooks";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";

const MobileSponsorLogoSelect = (props) => {
  const {sponsorID, context } = props;

  const [
    ,
    ,
    setLogo,
    removeLogo,
    getLogo,
    ,
  ] = useImageSelector(context, "logoMobile", 25000000);

  const navigate = useGolfstatusNavigate();

  return (
    <GSFileSelect
      id="logo-mobile"
      description="Tap or drag a file to upload. The image ratio is 4:1. Accepted file types are .JPG, .PNG, .GIF under 25MB."
      setSelectedFiles={(files) => {
        setLogo(files);
      }}
      removeSourceItem={() => removeLogo("logoMobile")}
      sourceList={getLogo()}
      accept=".jpg, .jpeg, .png"
      editImage={() => {
        navigate(`${sponsorID}/image?property=logoMobile`);
      }}
      minWidth={600}
      minHeight={150}
      ratio={4}
      warningClicked={() => {
        navigate(`${sponsorID}/image?property=logoMobile`);
      }}
      title={<GSButton buttonIcon={faArrowCircleUp} title="upload"></GSButton>}
      failedValidation={context.validationFailed}
    ></GSFileSelect>
  );
};

export default MobileSponsorLogoSelect;
